import { TagType } from '@coworkrz/cards/types';
import { DisplayedProduct } from '@coworkrz/products/data-access';
import { ProductUnit } from '@coworkrz/products/types';

export interface CartItem {
  id?: string;
  name: string;
  product: DisplayedProduct;
  quantity: number;
  startDate?: string; //for Subscription product
  price?: {
    amount: number;
    id: string;
    tag?: TagType;
    unit: ProductUnit;
  };
  priceUnit: ProductUnit;
  memberIds?: string[];
  quantityFactor?: number;
  _quantity: number; // = quantity * quantityFactor
}

export type Cart = {
  id?: string;
  cartItems: CartItem[];
  totalAmount: number;
  totalItems: number;
};

export enum MAX_MIN_QUANTITY {
  MAX = 24,
  MIN = 0,
}
